import { useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import type { UserRole } from '@audit/shared-types';

/**
 * Hook that checks the current user's role by attempting an admin API call.
 * Returns 'admin' if the user can access admin endpoints, 'user' otherwise.
 */
export function useUserRole(isApiAuthReady: boolean) {
  const [role, setRole] = useState<UserRole | null>(null);

  useEffect(() => {
    if (!isApiAuthReady) return;

    const checkRole = async () => {
      try {
        // Try to access the admin endpoint; if it succeeds, user is admin
        await apiClient.get('/admin/allowed-users', { timeout: 5000 });
        setRole('admin');
      } catch (error: unknown) {
        // 403 or any error means not admin
        if ((error as any)?.response?.status === 403) {
          setRole('user');
        } else {
          // Network error or timeout, assume user
          setRole('user');
        }
      }
    };

    void checkRole();
  }, [isApiAuthReady]);

  return role;
}
